import '@kendo/kendo.numerictextbox.js';
import "@kendo/kendo.dropdownlist.js";
import '@kendo/kendo.combobox.js';
import '@kendo/kendo.autocomplete.js';
import '@kendo/kendo.notification.js';

import 'jquery';
import 'jqueryui';
import { fn } from '@common/utils';
import {
    constants,
    IGridCustomization,
    NavKendoRegister
} from '@common/navkendo/kutils';
import * as kutils from '@common/navkendo/kutils';
import { ApplyStyle } from '@common/style';
import { ObservableArray, IObservableArray } from '@common/nav';
//import { INavGridImp, NavGridOptions, INavGrid } from './navkendo/navgrid';
export { NavKendoRegister }

/** Access Common Functionality to List Based Kendo widgets  */
export type ListWidget = kendo.ui.DropDownList | kendo.ui.AutoComplete | kendo.ui.ComboBox;

/** Common Options to Customized List based Widgets */
export type InfListOptions<T = Object> = InfCustomListOptions<T> & (kendo.ui.DropDownListOptions | kendo.ui.AutoCompleteOptions | kendo.ui.ComboBoxOptions);

export class InfNumericTextBox extends kendo.ui.NumericTextBox {
    constructor(element, options) {
        super(element, options);
    }

    _format: (format: string) => any;
}
NavKendoRegister(<any>InfNumericTextBox, "InfNumericTextBox", {});
(function () {
    // Overwrite _keypress, _parse to allow calculations in numerictextBox
    let
        _fn = InfNumericTextBox.fn,
        _keypress = "_keypress",
        _parse = "_parse",
        _origkeypress = _fn[_keypress],
        _origParse = _fn[_parse],
        rValidInput = /[0-9\.\,\/\*\-\+]/,
        rCustomInput = /^(\-?[^\*\-\+\/]+)([\/\*\-\+])([^\*\-\+\/]+)$/;

    function _fixKeyPress(this: InfNumericTextBox & { __numberFormat: string }, e: JQueryKeyEventObject) {
        var key = !e.altKey && String.fromCharCode(e.charCode),
            text = this.element.val();

        var numberFormat = this.__numberFormat || (this.__numberFormat = this._format(this.options.format));
        if (key && e.keyCode == 110 && numberFormat) { // NUMPAD DOT
            key = numberFormat['.'];
        }

        if (key && numberFormat && numberFormat[","] == key) {
            // avoid input of thousands seperator : will be misinterpreted
        } else {
            if (["*", "+", "-", "/"].indexOf(key) >= 0 || (text && typeof text === "string" && fn.indexOfAny(text, "/*-+") >= 0)) {
                if (rValidInput.test(key)) {
                    this["_key"] = 0;
                    return;
                }
            }
        }
        return _origkeypress.call(this, e);
    }
    function _fixParse(this: InfNumericTextBox, value, format: { numberFormat: { decimals: number } }) {
        var q: RegExpExecArray;
        if (typeof value == "string" && (q = rCustomInput.exec(value))) {
            let f1 = _origParse.call(this, q[1], format),
                f2 = _origParse.call(this, q[3], format),
                calc: number,
                op = q[2];

            switch (op) {
                case "+": calc = f1 + f2;
                    break;
                case "-": calc = f1 - f2;
                    break;
                case "*": calc = f1 * f2;
                    break;
                case "/": calc = f1 / f2;
                    break;
                default:
            }

            if (typeof calc == "number" && !isNaN(calc)) {
                let nf = format && format.numberFormat,
                    d = nf && nf.decimals;
                if (typeof d == "number") {
                    let exp = Math.pow(10, d);
                    calc = Math.round(calc * exp) / exp;
                }
                value = calc;
            }
        }
        return _origParse.call(this, value, format);
    }
    if (_origkeypress && _origParse) {
        _fn[_keypress] = _fixKeyPress;
        _fn[_parse] = _fixParse;
    }
})();

/** Custom  Option extension for List Base Widegts */
export interface InfCustomListOptions<T = any> {
    /** apply custom UI Logic:
    Show items in dropdown in one line and don't break at combo width */
    navCustom?: boolean;
    /** Field for DD Element Hint */
    hintField?: keyof T;
    /** Field for DD Element Disabled State */
    disabledField?: keyof T;
    /** (Typed) Value Field */
    dataValueField: keyof T;
    /** (Typed) text Field */
    dataTextField: keyof T;
}

/** Mixin Constructor for List Based Widget Types with our Customizations */
function CustomListMixin<TListWidget extends new (...args: any[]) => kendo.ui.Widget>(Base: TListWidget) {
    return class extends Base {
        public options: InfCustomListOptions;

        protected getIsDisabled(dataItem: any) {
            return dataItem && this.options.disabledField && dataItem[this.options.disabledField] === true;
        }
        protected getHint(dataItem: any) {
            return dataItem && this.options.hintField && dataItem[this.options.hintField];
        }
        constructor(...args: any[]) {
            var options = <InfListOptions>args[1] || <InfListOptions>{};
            if (options.navCustom === undefined) // Default : to custom Handling ...
                options.navCustom = true;
            // adjust default DD height
            if (options && !(options.height > 0))
                options.height = 400;
            if (options.navCustom) {
                options.dataBound = (e) => {
                    var me = <ListWidget><any>this;

                    // Show items in dropdown in one line and don't break at combo width
                    // -> Update width to new items
                    var hasVScroll = me.dataSource && me.dataSource.data().length > 8; // Scrollbar is present with 9 textonly items and more
                    var ddWidth = me.wrapper.width() - 6 + (hasVScroll ? 20 : 0);
                    me.list.css("min-width", ddWidth + "px").css("white-space", "nowrap");

                    $(".k-item", e.sender.list).each((_idx, e: HTMLOptionElement) => {
                        var dataItem = (<kendo.ui.DropDownList>me).dataItem(<any>$(e));
                        var strHint = this.getHint(dataItem);
                        if (strHint)
                            e.title = strHint;
                        if (this.getIsDisabled(dataItem)) {
                            e.disabled = true;
                            $(e).addClass("k-disabled");
                        }

                        // Adapt width for vertical scrollbar (cutoff otherwise)
                        $(e).css("padding-right", hasVScroll ? "20px" : "3px");
                    });
                };
            };

            super(...args);
            let me = <ListWidget><any>this;
            this.bind("select", (e: kendo.ui.DropDownListSelectEvent) => {
                var dataItem = me.dataItem(<any>e.item);
                if (dataItem && this.getIsDisabled(dataItem))
                    e.preventDefault();
            });

            // Hack: needed in HoverMenuBar- functionality
            this.bind("open", () => me.element.trigger("InfDropDownOpen"));
            this.bind("close", () => me.element.trigger("InfDropDownClose"));

            // Show items in dropdown in one line and don't break at combo width
            if (options.navCustom)
                me.list.width("auto");

            // see kendo.all.js 'propagateClassToWidgetWrapper' will work only with MutationObserver, so not with IE 10 :
            // "Re-implement" with ng Scope context if possible
            if (!window["MutationObserver"]) {
                var scope: ng.IScope;
                if ((scope = me["$angular_scope"])) {
                    var ngClass: string;
                    if (ngClass = me.element.attr('ng-class')) {
                        var prevClassList: string[];
                        this.one(constants.NavDestroy, scope.$watch<string>(ngClass, newValue => {
                            var targetClassList = me.wrapper && me.wrapper[0] && me.wrapper[0].classList;
                            var currClassList = ((newValue || "").match(/\S+\s*/g) || []).map(item => item.trim());
                            prevClassList = prevClassList || currClassList;
                            currClassList.forEach((cls) => {
                                if (prevClassList.indexOf(cls) < 0) {
                                    targetClassList.add(cls);
                                }
                            });
                            prevClassList.forEach((cls) => {
                                if (currClassList.indexOf(cls) < 0) {
                                    targetClassList.remove(cls);
                                }
                            });
                            prevClassList = currClassList;
                        }));
                    }
                    var ngDisabled;
                    if (ngDisabled = me.element.attr('ng-disabled')) {
                        this.one(constants.NavDestroy, scope.$watch<boolean>(ngDisabled, newValue => {
                            me.enable(!newValue);
                        }));
                    }

                    var ngHide;
                    if (ngHide = me.element.attr('ng-hide')) {
                        this.one(constants.NavDestroy, scope.$watch<boolean>(ngHide, newHide => {
                            var classList = me.wrapper[0].classList;
                            if (newHide) classList.add('ng-hide'); else classList.remove('ng-hide');
                        }));
                    }
                }
            }

            CreateDropDownOverlay(me);
        }

        destroy() {
            this.trigger(constants.NavDestroy);
            super.destroy();
        }
    };
}

export class InfDropDownList extends CustomListMixin(kendo.ui.DropDownList) { }
NavKendoRegister(<any>InfDropDownList, "InfDropDownList");

export class InfAutoComplete extends CustomListMixin(kendo.ui.AutoComplete) { }
NavKendoRegister(<any>InfAutoComplete, "InfAutoComplete");

// not localized (yet?)
kendo.ui.AutoComplete.fn.options.noDataTemplate = "Keine Daten";

export class InfComboBox extends CustomListMixin(kendo.ui.ComboBox) {
    constructor(element, options) {
        super(element, options);

        // Auto Open on dblclick, onfoucs when empty
        var input = this.input;
        input.on("focus.cbnav", () => {
            if (!this.value())
                this.open();
        });
        input.on("dblclick.cbnav", (e) => { this.open(); });
        this.one(constants.NavDestroy, () => input.off(".cbnav"));
    }
}
NavKendoRegister(<any>InfComboBox, "InfComboBox");

/** Typeuard Func for InfNotificationEntry */
function IsNotificationEntry(check: any): check is InfNotificationEntry {
    var r: InfNotificationEntry = check;
    return r && (typeof r.identifier === "string");
}
/** Extended kendo notification : - Filtering/ Removing Notification conditionally (not supported in base functionality) */
export class InfNotificationList extends kendo.ui.Notification implements IInfNotification {
    /** 'data' - Marker for  attached ItemId */
    private static _navId = "navId";
    /** Total Count of 'active' Notifications; Caution : with animation will not equal getNotifications().length! */
    public TotalCount: number = 0;
    public options: kendo.ui.NotificationOptions;

    /** Constructor */
    constructor(element: Element, options?: kendo.ui.NotificationOptions) {
        super(element, options);
        options = this.options;
        this.element.show(); // TODO : gets hidden in super constructor (?)

        this.element.addClass("idms_NotificationContainer");

        // Custom 'change' event on show/hide (TODO : $(this.element).trigger("resize") : only as we consume it this way ...)
        this.bind("show", (e: kendo.ui.NotificationShowEvent) => { this.TotalCount++; this.trigger("change"); $(this.element).trigger("resize"); });
        this.bind("hide", (e: kendo.ui.NotificationHideEvent) => { this.TotalCount--; this.trigger("change"); $(this.element).trigger("resize"); });
    }

    /** Destructor */
    destroy() {
        this.element.removeClass("idms_NotificationContainer");

        super.destroy();
    }

    /**
     * Shows a notification by type
     */
    public AddNotification(entry: InfNotificationEntry) {
        var message = entry.message,
            prevItems = this.getNotifications().toArray() || [],
            identifier = ((entry.group || "") + '~') + (entry.identifier || kendo.guid()),
            navIdMarker = InfNotificationList._navId;

        // Remove old notifications with the same message
        this.RemoveNotifications(e => e.innerText === entry.message);

        // Remove item with configured identifier if any
        this.RemoveNotifications(identifier);

        // Handle Title if set (TODO : extend templates for nices display of title?)
        var showConfig = {
            content: (entry.title ? $("<b>" + entry.title + "<br><br></b>")[0].outerHTML : "") + entry.message
        };

        if (entry.customData) {
            $.extend(showConfig, entry.customData);
        }
        // add new Notification (unfortunately base functionality does not return added entry ...)
        if (this.options.animation == false) this.one("show", (e) => $(e.element).show());
        super.show(showConfig, entry.messageType);
        var newItem = this.FilterNotifications(element => prevItems.indexOf(element) < 0 && !$(element).data(navIdMarker));

        let hint = entry.hint;
        if (hint == undefined) {
            let all = $("<div></div>").append(message);
            all.find("button").remove();
            hint = $(all[0]).text();
        }
        // Mark created item with configured identifier
        newItem.data(navIdMarker, identifier).attr("title", hint);
        return fn.proxy(this.RemoveNotifications, this, identifier);
    }

    /**
     * Filter Notifications
     * @param filter : if string : it's the identifier/group from "AddNotification"
     */
    public FilterNotifications(filter: InfNotificationFilter) {
        if (IsNotificationEntry(filter))
            filter = filter.identifier;

        if (typeof filter == "string") {
            var strFilter = filter;
            // Remap to filter by navId/group Function
            filter = (element: HTMLDivElement) => ($(element).data(InfNotificationList._navId) || "").indexOf(strFilter) >= 0;
        }

        if (typeof filter == "function") {
            var funcFilter = filter;
            return this.getNotifications().filter((idx, element: HTMLDivElement) => funcFilter(element));
        } else {
            return $(filter);
        }
    }

    /**
     * Remove Notification(s) [see Base Functionality "hide" (does not allow "filtered" hide)]
     * @param filter opt filter; if not set
     */
    RemoveNotifications(filter?: InfNotificationFilter) {
        var me = this,
            toRemove = this.FilterNotifications(filter == undefined ? fn.ToFunc(true) : filter); // no filter : all

        // see "kendo.ui.Notification.fn.hide"
        if (me.options.appendTo && $.isFunction(me["_hideStatic"])) {
            $(toRemove).each((idx, element) => me["_hideStatic"]($(element)));
        } else {
            $(toRemove).each((idx, element) => {
                var popup = $(element).data("kendoPopup");
                if (popup) {
                    popup.close();
                }
            });
        }
    }
}
NavKendoRegister(<any>InfNotificationList, "InfNotificationList",
    // Default Options TODO : which are part of our customization logic and must be enforced, which are default, and which should be configurable
    <kendo.ui.NotificationOptions>{
        autoHideAfter: 0,
        hideOnClick: false,
        button: true,
        animation: false, // "change" event will trigger before animatin end
        // default template is : '<div class="k-notification-wrap"><span class="k-icon k-i-note">#=typeIcon#</span>#=content#<span class="k-icon k-i-close">Hide</span></div>'
        // this way we could overwrite them (or add new 'messageTypes')
        /** templates:
        ['error', 'warning', 'success', 'info'].map(name => {
            return {
                type: name,
                template: '<div class="k-notification-wrap"><span class="k-icon k-i-note">#=typeIcon#</span>#=content#<span class="k-icon k-i-close">Hide</span></div>'
            }
        }) */
    },
    // added Events
    ["change"]
);

/** IInfNotification Implementation based on DropDown */
export class InfNotificationDropDown extends kendo.ui.DropDownList implements IInfNotification {
    constructor(element, options) {
        super(element, resolveOptions(options));
        var me = this;
        this.wrapper.css("width", "100%"); // really ?

        // Setup Close Button functionaliity
        this.wrapper.on("click.navNotify", ".k-i-close", (e) => {
            var idx = this.select();
            me.select(-1);
            me._items.splice(idx, 1);
            me.select(idx > 0 ? idx - 1 : 0);
            me.close();
            e.preventDefault();
        });

        this.bind(constants.NavDestroy, () => this.wrapper.off(".navNotify"));

        this._items = kutils.AsObservableArray(this.dataSource.data());

        var onChange = fn.proxy(() => {
            this.wrapper.toggle((this.TotalCount = this._items.length) > 0);
            if (this.TotalCount > 0 && (this.select() < 0)) {
                this.select(0);
            }
        }, this);
        this.dataSource.bind("change", onChange);
        onChange();

        /** adjust Default Options */
        function resolveOptions(options: kendo.ui.DropDownListOptions) {
            options = options || <kendo.ui.DropDownListOptions>{};

            // TODO adjust templates
            options.template = '<div class="k-widget k-notification k-notification-#=data.messageType#"><div class="k-notification-wrap"><span class="k-icon k-i-note">xxx</span>#= data.message#<span class="k-icon k-i-close">Hide</span></div></div>';
            options.valueTemplate = '<div class="k-widget k-notification k-notification-button k-notification-#=data.messageType#"><div class="k-notification-wrap" style="padding: 0" ><span class="k-icon k-i-note">xxx</span>xxx#= data.message#<span class="k-icon k-i-close">Hide</span></div></div>';

            options.dataSource = new kendo.data.DataSource({ data: new ObservableArray([]) });

            return options;
        }
    }
    private _items: IObservableArray<InfNotificationEntry>;

    destroy() {
        this.trigger(constants.NavDestroy);
        super.destroy();
    }
    public TotalCount: number;

    public AddNotification(entry: InfNotificationEntry) {
        var identifier = entry.identifier = ((entry.group || "") + '~') + (entry.identifier || kendo.guid());

        var remove = () => {
            this.RemoveNotifications(identifier);
        };
        remove();
        this._items.push(entry);
        return remove;
    }

    public RemoveNotifications(filter?: InfNotificationFilter) {
        var toRemove = this.FilterNotifications(filter);
        toRemove.forEach(item => this._items.remove(item), this);
    }

    public FilterNotifications(filter: InfNotificationFilter) {
        if (typeof filter == "string") {
            // Remap to filter by navId/group Function
            var strFilter = <string>filter;
            filter = <any>((element: InfNotificationEntry) => (element.identifier && element.identifier.indexOf(strFilter) >= 0));
        }

        if (typeof filter == "function") {
            var funcFilter = <any>filter;
            return this._items.filter(c => funcFilter(c));
        } else {
            throw new Error("Unsupported Filter");
        }
    }
}
NavKendoRegister(<any>InfNotificationDropDown, "InfNotificationDropDown");

//#region InfNotification

/** Common Interface for a UI Control displaying notifications */
export interface IInfNotification {
    /** Add Notification Entry to Display */
    AddNotification(entry: InfNotificationEntry): () => void;

    /** Remove Notification Entry */
    RemoveNotifications(filter?: InfNotificationFilter);
}

/** ways to filter a Notification Entry
  * string : identifier or group
  */
export type InfNotificationFilter = InfNotificationEntry | string | ((element: HTMLDivElement) => boolean);

/** configuration for a new Notification Entry
* messageType : error, info, warning, success
* identifier/group : allows identifying added items
*/
export type InfNotificationEntry = {
    /** TODO for i.e. Search Notifcation as it was */
    title?: string,
    /** Display Message as html of Message, AS HTML! */
    message: string,
    /* Explicit hint, if not set : resolved via message */
    hint?: string,
    messageType?: "warning" | "error" | "info",
    identifier?: string,
    group?: string,
    /** custom ext., allows angularjs bind ...  */
    customData?: any;
};

//#endregion

/** Conditionally apply Row/ Cell Customizations to data Rows of Grid, returns unbind function */
export function BindListCustomizations(list: kendo.ui.ListView, customization: IGridCustomization, config?: { CurrentUser?: string }) {
    var rowItems = customization && customization.RowCustomizations;
    if (!((rowItems && rowItems.length) && (list instanceof kendo.ui.ListView)))
        return fn.noop;

    var rowMatcher = kutils.ensureRowInfo(list, customization, config).RowMatcher;

    /** Container of Action to reset current Customizations */
    var reset = new Array<() => void>();

    function applyCustomizations() {
        reset.length = 0;
        var rows = list.items();

        rows.each((idx, el) => {
            var item = list.dataItem(el),
                info = item && rowMatcher(item);

            if (item) {
                if (info) {
                    reset.push(ApplyStyle($(el), info));
                };
            }
        });
    };

    list.bind("dataBound", applyCustomizations);
    applyCustomizations();

    // Setup Reset
    var unbind = (remove: boolean) => {
        unbind = fn.noop;
        if (list) {
            list.unbind("dataBound", applyCustomizations);
            if (remove) {
                reset.forEach(r => r());
            }
        }
        reset.length = 0;
    };
    list.bind(constants.NavDestroy, () => unbind(false));
    return () => unbind(true);
}

/**  Create Overlay "behind" DropwDownList DropDownElement  to hide heavyweight objects (PDF, ...) */
export function CreateDropDownOverlay(dropDown: ListWidget) {
    if (!kutils.UseOverlay() || !dropDown || !dropDown.wrapper || !dropDown.ul)
        return;

    // WTF ???
    if (dropDown instanceof kendo.ui.AutoComplete) {
        var overlay = kutils.CreateOverlay(dropDown["popup"].element, { Left: 3, Top: 3, Width: 6, Height: 7 });
    }
    else {
        var overlay = kutils.CreateOverlay(dropDown.ul, { Left: 3, Top: 3, Width: 6, Height: 7, Insert: dropDown.wrapper });
    }

    dropDown.bind("open", overlay.Show);
    dropDown.bind("close", overlay.Hide);
    dropDown.element.on("remove", overlay.Hide);
}

//#endregion
declare global {

    /**  Defined kendo Widgets in this file are automatically available on JQuery ...*/
    interface JQuery {

        kendoInfNumericTextBox(options: kendo.ui.NumericTextBoxOptions): JQuery;
        data(key: "kendoInfNumericTextBox"): InfNumericTextBox;

        /** Custom  Notification as List */
        kendoInfNotificationList(options: kendo.ui.NotificationOptions): JQuery;
        data(key: "kendoInfNotificationList"): InfNotificationList;

        /** Custom  Notification as List */
        kendoInfNotificationDropDown(options: kendo.ui.DropDownListOptions): JQuery;
        data(key: "kendoInfNotificationDropDown"): InfNotificationDropDown;
    }
}
